import React from 'react';
import Moment from 'react-moment';
import { useMap } from 'react-leaflet';

export default function InfoReviewComplaint({ complaints, itemCliked, setItemCliked }) {
  const map = useMap();

  return (
    <div>
      <div className="list-ocorrencias" style={{ cursor: "pointer" }}>
        <ul>
          {complaints.map((complaints, key) => (
            <li key={complaints.id}
              className="container-yellow"
              style={key === itemCliked ? { backgroundColor: "#feffc4" } : { backgroundColor: "white" }}
              onClick={() => {
                setItemCliked(key);
                map.setView({ lat: complaints.latitude, lng: complaints.longitute }, 18);
              }}
            >
              <strong>CÓDIGO:
                <span>{complaints.reference}</span>
              </strong>

              <strong>TIPO:
                <span>{complaints.area}</span>
              </strong>

              <strong>BAIRRO:
                <span>{complaints.neighborhood}</span>
              </strong>

              <strong>CRIAÇÃO:
                <span>
                  <Moment locale format={'DD/MM/YYYY HH:mm'}>
                    {complaints.createdAt}
                  </Moment>
                </span>
              </strong>

              <strong>STATUS:
                <span className={complaints.status === 'Em análise' ? 'analise' :
                  complaints.status === 'Resolvido' ? 'resolvido' :
                    complaints.status === 'Indeferido' ? 'indeferido' :
                      //  complaints.status==='Homologado' ? 'homologado' :
                      complaints.status === 'Novo' ? 'novo' : 'novo'}>{complaints.status}
                </span>
              </strong>

              <strong>RESPONSÁVEL:
                <span>{complaints.executorName === undefined ? 'Sem executor' : complaints.executorName}</span>
              </strong>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}